import { useState } from 'react'
import { Menu, X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { NAV_ITEMS } from '@/constants'

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  return (
    <header className="sticky top-0 z-50 w-full border-b border-primary-100/50 bg-white/95 backdrop-blur-md supports-[backdrop-filter]:bg-white/80 shadow-sm">
      <div className="container flex h-16 items-center px-4 lg:px-6">
        <div className="flex items-center justify-center group cursor-pointer">
          <div className="p-1 rounded-lg group-hover:scale-105 transition-all duration-300">
                      <img src="/icon.svg" alt="AIBoard" className="h-8 w-8" />
        </div>
        <span className="ml-3 text-xl font-bold text-primary-600">AIBoard</span>
        </div>
        
        {/* Desktop Navigation */}
        <nav className="hidden md:flex ml-auto items-center gap-8">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="relative text-sm font-medium transition-all duration-300 text-neutral-700 hover:text-primary-600 group"
            >
              {item.title}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-primary-600 to-accent-600 transition-all duration-300 group-hover:w-full"></span>
            </a>
          ))}
          <Button 
            size="sm" 
            className="ml-6 bg-gradient-to-r from-primary-600 to-primary-700 hover:from-primary-700 hover:to-primary-800 text-white shadow-md hover:shadow-lg transition-all duration-300 transform hover:scale-105"
            onClick={() => window.open('https://dashboard.freightmaster.ai/', '_blank')}
          >
            Launch Dashboard
          </Button>
        </nav>

        {/* Mobile Menu Button */}
        <Button
          variant="ghost"
          size="icon"
          className="ml-auto md:hidden hover:bg-primary-50 transition-all duration-300"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? 
            <X className="h-6 w-6 text-neutral-700" /> : 
            <Menu className="h-6 w-6 text-neutral-700" />
          }
          <span className="sr-only">Toggle menu</span>
        </Button>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur-md border-t border-primary-100/50">
          <div className="px-4 py-6 space-y-4">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="block text-base font-medium text-neutral-700 hover:text-primary-600 transition-all duration-300 py-2 px-3 rounded-lg hover:bg-primary-50"
                onClick={() => setIsMenuOpen(false)}
              >
                {item.title}
              </a>
            ))}
            <div className="pt-4">
              <Button 
                size="sm" 
                className="w-full bg-gradient-to-r from-primary-600 to-primary-700 hover:from-primary-700 hover:to-primary-800 text-white shadow-md hover:shadow-lg transition-all duration-300"
                onClick={() => window.open('https://dashboard.freightmaster.ai/', '_blank')}
              >
                Launch Dashboard
              </Button>
            </div>
          </div>
        </div>
      )}
    </header>
  )
} 